import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { apiResponse } from '../schemas/common.schema';

const c = initContract();

export const RegionResponseSchema = z.object({
  _id: z.string(),
  region_iso: z.string(),
  region_name: z.string(),
});

export const regionsContract = c.router({
  getRegions: {
    method: 'GET',
    path: '/regions',
    query: z.object({
      cursor: z.string().optional(),
      limit: z.coerce.number().optional(),
      regionIso: z.string().optional(),
      search: z.string().optional(),
      locale: z.string().optional(),
    }),
    responses: { 200: apiResponse(z.array(RegionResponseSchema)) },
  },
});

export type RegionResponseDto = z.infer<typeof RegionResponseSchema>;
